export default __webpack_public_path__ + "static/Nerd-e4eb5ccd669ffcf11e79b1b6475b3712.png";